import {ErrorHighlighter} from "../../ui-components/light/error-highlighter";
import {arrEquals}        from "../../utils/collections";
import {cs}               from "../chain-services";
import {UseState}         from "../use-state";

export const FormErrorHighlighter = ({next}) => cs(
    ["state", (_, next) => UseState({next})],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ({state, eh}) => next({
        start: (path) => {
            state.onChange({path});
            eh.start();
        },
        errCss: (path) => arrEquals(state.value?.path, path) && eh.css || undefined,
    }),
);
